import { Typography } from '@material-ui/core';
import React, { Component } from 'react';

export class RatingIndexView extends Component {
  render() {
    return (
      <div>
        <Typography variant="h4" gutterBottom>
          RatingIndex Page
        </Typography>
      </div>
    );
  }
}

export default RatingIndexView;
